import { useFormContext } from "react-hook-form";

export const SelectedData = (name: string) => {
  const { watch } = useFormContext();
  const watchData = watch(name);

  return watchData
    ? Object.keys(watchData)
        .map((data) => watchData[data])
        .filter((data) => data !== false)
    : [];
};
